<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">保单编号</span>
        <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">保单状态</span>
        <lzDicSelect :transfer="true" v-model="searchParams.policyStatus" dicType="POLICY_STATUS"> </lzDicSelect>
      </div>
      <div class="input-item">
        <span class="label">签单日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.signDate"
          @on-change="searchParams.signDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">生效日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.effectDate"
          @on-change="searchParams.effectDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">供应商</span>
        <lzDicSelect v-model="searchParams.suppliers" :transfer="true" dicType="SUPPLIERS"> </lzDicSelect>
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyId" @on-change="companyChange()" transfer clearable filterable>
          <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">产品名称</span>
        <Select v-model="searchParams.productId" transfer clearable filterable>
          <Option v-for="(item, index) in searchProductList" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">犹豫止期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.expirationDate"
          @on-change="searchParams.expirationDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">产品类型</span>
        <lzDicSelect v-model="searchParams.productType" :transfer="true" dicType="PRODUCT_TYPE2"> </lzDicSelect>
      </div>
      <div class="input-item">
        <span class="label">团队</span>
        <Select v-model="searchParams.groupId" transfer clearable filterable>
          <Option v-for="(bean, i) in groupList" :key="i" :value="bean.id">{{ bean.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">签单代理人</span>
        <Input v-model="searchParams.signAgent" placeholder="请输入姓名或工号" clearable />
      </div>
      <div class="input-item">
        <span class="label">签单职级</span>
        <lzDicSelect v-model="searchParams.agentLevel" dicType="IFA_RANK" :transfer="true" clearable> </lzDicSelect>
      </div>
      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" clearable>
          <Option value="0">待结算</Option>
          <Option value="1">已结算</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">所属结算报表</span>
        <Input v-model="searchParams.reportName" placeholder="请输入" clearable />
        <Checkbox v-model="searchParams.reportIsNull" true-value="1" false-value="0" transfer>为空</Checkbox>
      </div>
      <div class="input-item">
        <span class="label">结算日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">佣金项类型</span>
        <Select v-model="searchParams.commissionTypeList" :max-tag-count="1" multiple clearable transfer>
          <Option value="1">基础销售佣金</Option>
          <Option value="11">个人Bonus</Option>
          <Option value="12">管理津贴</Option>
          <Option value="13">推荐奖</Option>
          <Option value="14">辅导奖</Option>
          <Option value="15">育成奖</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">对账状态</span>
        <Select v-model="searchParams.checkStatus" clearable>
          <Option value="1">待确认</Option>
          <Option value="2">已确认待打款</Option>
          <Option value="3">打款成功</Option>
        </Select>
        <Checkbox v-model="searchParams.checkIsNull" true-value="1" false-value="0" transfer>为空</Checkbox>
      </div>
      <div class="input-item">
        <span class="label">打款日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.payDate"
          @on-change="searchParams.payDate = $event"
        ></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">佣金归属</span>
        <Input v-model="searchParams.owerUser" placeholder="请输入姓名或工号" clearable />
      </div>
      <div class="input-item">
        <span class="label">保单期数</span>
        <Input v-model="searchParams.commissionIndex" placeholder="请输入" clearable />
      </div>

      <div class="input-item">
        <span class="label">特殊标记单</span>
        <Select v-model="searchParams.isReferral" transfer>
          <Option value="999">全部</Option>
          <Option value="1">是</Option>
          <Option value="0">否</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" ghost @click="handleExport()">导出</Button>
      </div>
    </div>
    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <div class="statistics">
        <span>保单：{{ statistics.policyNum || 0 }}</span>
        <span>保费(美元)：{{ statistics.feeSum || 0 }}</span>
        <span
          >已打款佣金(港币)
          <Poptip trigger="hover" content="content">
            <span class="tip-icon">?</span>
            <div slot="content">
              <p>已打款销售佣金的单，但推荐、辅导、团队、年度bouns未打款的佣金汇总</p>
            </div> </Poptip
          >：{{ statistics.paidCommission || 0 }}</span
        >
        <span>剩余未打款（港币）：{{ statistics.unpaidCommission || 0 }}</span>
        <span>佣金合计(港币)：{{ statistics.commissionSum || 0 }}</span>
      </div>
      <Table :columns="columns" :data="tableData"> </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        :page-size-opts="[10, 20, 30, 50, 100]"
        style="text-align: center"
      />
    </div>
  </div>
</template>

<script>
import lzDicSelect from '@/components/commons/lzDicSelect';
import { pageTool, common } from '@/api/mixins';
import { config } from '../index.config.js';

const LIST_URL = '/buz/ifaCommissionLog/querySettleLogPage';
const DATE_RANGE_KEYS = ['signDate', 'expirationDate', 'effectDate', 'settlementDate', 'payDate'];

const DEFAULT_SEARCH_PARAMS = {
  expirationDate: [],
  effectDate: [],
  signDate: [],
  settlementDate: [],
  payDate: [],
  isReferral:'999'
};

export default {
  name: 'BasicTab',
  mixins: [pageTool, common, config],
  components: { lzDicSelect },
  data() {
    return {
      statistics: {},
      groupList: [],
      companyList: [],
      searchProductList: [],
      searchParams: { ...DEFAULT_SEARCH_PARAMS }
    };
  },
  mounted() {
    this.getColumns();
    this.queryCompanyList();
    this.getGroupList();
    this.initListParams(LIST_URL);
  },
  activated() {
    this.getList();
  },
  methods: {
    handleExport() {
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/ifaCommissionLog/export', params, 'POST');
    },
    companyChange() {
      if (!this.searchParams.companyId) {
        this.$set(this.searchParams, 'productId', '');
      }
      this.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: this.searchParams.companyId }
      }).then(res => {
        this.searchProductList = res.data;
      });
    },
    getGroupList() {
      this.$http({
        url: '/buz/groupBase/read/list',
        type: 'POST',
        data: { pageSize: 999, pageNo: 1 }
      }).then(res => {
        this.groupList = res.data;
      });
    },
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        this.companyList = res.data;
      });
    },
    transformDateRanges(params) {
      DATE_RANGE_KEYS.forEach(key => {
        if (params[key] && params[key][0]) {
          params[key + 'Start'] = params[key][0];
          params[key + 'End'] = params[key][1];
        }
        delete params[key];
      });
    },
    setListParams(params) {
      if (params.commissionTypeList && params.commissionTypeList.includes('15')) {
        params.commissionTypeList.push('16');
      }
      if (params.isReferral == '999') {
        delete params.isReferral;
      }
      this.transformDateRanges(params);
      this.$nextTick(() => {
        this.getStatistics(params);
      });
    },
    getStatistics(params) {
      params = JSON.parse(JSON.stringify(params));
      delete params.status;
      this.$http({
        url: '/buz/ifaCommissionLog/statistics',
        type: 'POST',
        data: params
      }).then(res => {
        this.statistics = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding-right: 280px;
  .input-item {
    display: flex;
    align-items: center;
    width: 25%;
    margin-bottom: 16px;
    padding-right: 20px;
    .label {
      white-space: nowrap;
      margin-right: 8px;
    }
    > div,
    /deep/ .ivu-input-wrapper,
    /deep/ .ivu-select,
    /deep/ .ivu-date-picker {
      flex: 1;
    }
  }
  .btn-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    button {
      margin-right: 8px;
    }
  }
}
/deep/.ivu-checkbox-wrapper {
  white-space: nowrap;
  margin-left: 10px;
}
/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
  padding-right: 0 !important;
}
.statistics {
  height: 30px;
  span {
    padding-right: 20px;
  }
}
</style>
